import * as S from './styles'

const EmptyAdress = () => {
  return (
    <>
      <S.ProfileBox>
        <p className="description text-center">
          Você ainda não tem endereços cadastrados :(
        </p>
      </S.ProfileBox>
    </>
  )
}

export default EmptyAdress
